
class PurchaseInvoiceDetailViewController extends InvoiceDetailViewController
{
    static newInstance(): PurchaseInvoiceDetailViewController {
        let vc = new PurchaseInvoiceDetailViewController("purchase-invoice-detail-view");
        vc.initWithResource("layout/invoices/PurchaseInvoiceDetailView.html");
        return vc;
    }

    private uploadButton:MUIButton = null;
    private viewFilesButton:MUIButton = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.uploadButton = MUIOutlet(this, "upload-btn", "MUIButton");
        this.uploadButton.setAction(this, function(this:PurchaseInvoiceDetailViewController){
            this.openUploadPanel();
        });
        this.setTooltip(this.uploadButton, MIOLocalizeString("UPLOAD_FILE", "Upload file"));

        this.viewFilesButton = MUIOutlet(this, "view-files-btn", "MUIButton");
        this.viewFilesButton.setAction(this, function(this:PurchaseInvoiceDetailViewController){
            this.openFilesViewController();
        });
        this.setTooltip(this.viewFilesButton, MIOLocalizeString("ATTACHED_FILES", "Attached files"));
    }

    protected updateUI(){
        super.updateUI();
        this.loadFilesCount(false);
    }

    // The count of attached files on the files icon, asked once per invoice (and again after an upload).
    private filesCountInvoiceID:string = null;
    private loadFilesCount(force:boolean){
        if (!this.viewIsLoaded || this.invoice == null) return;
        let invoice = this.invoice;
        if (!force && this.filesCountInvoiceID == invoice.identifier) return;
        this.filesCountInvoiceID = invoice.identifier;

        let pf = "deletedAt = null && entityID = " + invoice.identifier;
        DBHelper.queryObjectsWithCompletion("FileAttachment", null, MIOPredicate.predicateWithFormat(pf), [], this, function(this:PurchaseInvoiceDetailViewController, files:FileAttachment[]){
            if (this.invoice !== invoice) return;
            let count = files != null ? files.length : 0;
            this.setBadge(this.viewFilesButton, count, false);
            this.setTooltip(this.viewFilesButton, MIOLocalizeString("ATTACHED_FILES", "Attached files") + (count > 0 ? " · " + count : ""));
        });
    }

    private openFilesViewController(){
        let vc = InvoiceFilesViewController.newInstance();
        vc.document = this.invoice;
        this.presentViewController(vc, true);
    }

    private openUploadPanel(){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let panel = MUIOpenPanel.openPanel();
        panel.allowedFileTypes = ["pdf", "png", "jpg", "jpeg"];

        panel.beginSheetModalForWindow(ad.window, this, function(this:PurchaseInvoiceDetailViewController, result:number){
            if (result == MIOFileHandlingPanel.OKButton) {
                let file = panel.files[0];
                if (file == null) return;                           
                ad.webService.uploadInvoiceFile(this.invoice, file, (code:number, data:any) => {
                    if (code == 200) {
                        AppHelper.showInfoMessage(null, MIOLocalizeString("SUCCESS", "SUCCESS"), MIOLocalizeString("FILE_UPLOADED_SUCCESSFULLY", "File uploaded successfully."));
                        this.loadFilesCount(true);
                    } else {
                        AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("COULDNT_UPLOAD_FILE", "Couldn't upload file. Please try again."));
                    }
                });
            }
         });
    }
}
